import { Amplitude } from 'components/consent-restricted-scripts/Amplitude';
import { FacebookPixel } from 'components/consent-restricted-scripts/FacebookPixel';
import { GoogleAnalytics } from 'components/consent-restricted-scripts/GoogleAnalytics';
import AppSettings from 'settings/AppSettings';
import React from 'react';
import env from '@tock/shared/utils/env';

/**
 * Conditionally loads consent-restricted scripts based on user-provided consent level
 */
export const ConsentRestrictedScripts: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const environment = env.get(AppSettings.API_BASE);
  return environment !== 'local' ? (
    <>
      <Amplitude />
      <GoogleAnalytics />
      <FacebookPixel />
    </>
  ) : null;
};
